import { render, staticRenderFns } from "./volunteer.vue?vue&type=template&id=6a54442c&scoped=true"
import script from "./volunteer.vue?vue&type=script&lang=js"
export * from "./volunteer.vue?vue&type=script&lang=js"
import style0 from "./volunteer.vue?vue&type=style&index=0&id=6a54442c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7907ed7515d572276d45114f834f04a7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a54442c",
  null
  
)

export default component.exports